export default "__VITE_ASSET__mEe4JuS6__"